import { Suspense } from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { routes } from "./Routes/Routes";
import Layout from "./components/Layout/wrapper";
import ProtectedRoute from "./components/Auth/ProtectedRoute";

const Loading = () => (
  <div className="flex min-h-screen items-center justify-center bg-white text-sm text-[#4b5563]">
    Loading...
  </div>
);

const loginRoute = routes.find((route) => route.path === "/login");
const appRoutes = routes.filter((route) => route.path !== "/login");
const LoginPage = loginRoute?.component;

export default function App() {
  return (
    <Router>
      <Suspense fallback={<Loading />}>
        <Routes>
          {LoginPage && <Route path="/login" element={<LoginPage />} />}
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              {appRoutes.map(({ path, component: Component }) => (
                <Route key={path} path={path} element={<Component />} />
              ))}
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </Router>
  );
}
